module.exports = __webpack_public_path__ + "media/qrcode-access-denied.cce87f77.wav";